import FinalPage from "./FinalPage";

export default FinalPage;
